module.exports = __webpack_public_path__ + "static/media/3.4cf91c8e.png";